import { Button } from '@mui/material';
import Collapsible from 'components/collapsible';
import List from 'components/list/list';
import ListCell from 'components/list/list-cell';
import ListRow from 'components/list/list-row';
import TextField from 'components/text-field';
import Active from 'views/production-systems/assets/Active';
import Inactive from 'views/production-systems/assets/Inactive';
import { usePondsState } from 'views/production-systems/context/ponds-context';
import { Pond, PondStatus } from 'views/production-systems/types/pond.type';
import React from 'react';
import { useIntl } from 'react-intl';

type Props = {
  selectedPonds: Pond[];
  setSelectedPonds: React.Dispatch<React.SetStateAction<Pond[]>>;
};

const getIcon = (type: PondStatus | undefined) => {
  return type === PondStatus.active ? (
    <Active style={{ verticalAlign: 'middle' }} />
  ) : (
    <Inactive style={{ verticalAlign: 'middle' }} />
  );
};

const PAGE_NAME_ID = 'productionSystems.listSelectedPonds';

const ListSelectedPonds: React.FC<Props> = ({ selectedPonds, setSelectedPonds }) => {
  const { registrationDate, releasePonds } = usePondsState();
  const intl = useIntl();

  const handleReleasePond = (pondId: string) => {
    releasePonds([pondId]);
    setSelectedPonds((prev) => [...prev.filter((prevPond) => prevPond.pondId !== pondId)]);
  };

  return (
    <>
      <TextField
        label={intl.formatMessage({ id: `${PAGE_NAME_ID}.registrationDate` })}
        dark
        disabled
        value={registrationDate.format('DD/MM/YYYY')}
      />
      <Collapsible
        label={intl.formatMessage({ id: `${PAGE_NAME_ID}.selectedPonds` })}
        count={selectedPonds.length}
        open={true}>
        <List
          dark
          options={[
            {
              label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.name` }),
              id: 'name',
            },
            {
              label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.zone` }),
              id: 'zone',
            },
            {
              label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.status` }),
              id: 'status',
              align: 'center',
            },
            {
              label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.activeDays` }),
              id: 'activeDays',
              align: 'right',
            },
            {
              label: '',
              id: 'actions',
            },
          ]}>
          {selectedPonds.map((pond) => (
            <ListRow key={pond.pondId}>
              <ListCell>{pond.pondName}</ListCell>
              <ListCell>{pond.zoneName}</ListCell>
              <ListCell align="center">
                {getIcon(pond.pondStatus)}
              </ListCell>
              <ListCell align="right">{pond.activeInactiveDays}</ListCell>
              <ListCell align="right">
                <Button onClick={() => handleReleasePond(pond.pondId)}>{intl.formatMessage({ id: 'general.remove' })}</Button>
              </ListCell>
            </ListRow>
          ))}
        </List>
      </Collapsible>
    </>
  );
};

export default React.memo(ListSelectedPonds);
